/** @typedef {import('../../../../../types/fees').PaymentType} PaymentType */

export default {
  paytrace: 'paytrace',
  multipass: 'multipass',
  /** @type {PaymentType} */
  ach: 'ach',
  bankTransfer: 'bankTransfer',
  card: 'card',
  /** @type {PaymentType} */
  credit: 'credit',
  /** @type {PaymentType} */
  debit: 'debit',
  /** @type {PaymentType} */
  cash: 'cash',
  visa: 'Visa',
  masterCard: 'MasterCard',
  americanExpress: 'American Express',
  discoverCard: 'Discover Card',
};
